import React, { useRef, useState } from "react";
import "../assets/styles/Contact.scss";
import emailjs from "@emailjs/browser";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import TextField from "@mui/material/TextField";

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [messageError, setMessageError] = useState(false);

  const formRef = useRef<HTMLFormElement | null>(null);

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const hasNameError = name.trim() === "";
    const hasEmailError = email.trim() === "";
    const hasMessageError = message.trim() === "";

    setNameError(hasNameError);
    setEmailError(hasEmailError);
    setMessageError(hasMessageError);
    if (hasNameError || hasEmailError || hasMessageError) return;
    emailjs
      .send(
        "service_qhhui5n",     
        "template_qfczuaa",    
        { name, email, message },
        "RKNIdy72qxrez8g4i"   
      )
      .then(() => {
        setName("");
        setEmail("");
        setMessage("");
      })
      .catch((error) => {
        console.error("EmailJS error:", error);
      });
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>CONTACT ME</h1>
          <p>
            Got a project waiting to be realized? Let&apos;s collaborate and make
            it happen!
          </p>

          <Box
            ref={formRef}
            component="form"
            onSubmit={sendEmail}
            noValidate
            autoComplete="off"
            className="contact-form"
          >
            <div className="form-flex">
              <TextField
                fullWidth
                required
                label="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                error={nameError}
                helperText={nameError ? "Please enter your name" : ""}
              />

              <TextField
                fullWidth
                required
                label="Email / Phone"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={emailError}
                helperText={
                  emailError ? "Please enter your email or phone number" : ""
                }
              />
            </div>

            <TextField
              fullWidth
              required
              label="Message"
              multiline
              rows={10}
              className="body-form"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              error={messageError}
              helperText={messageError ? "Please enter the message" : ""}
            />

            <Button
              type="submit"
              variant="contained"
              endIcon={<SendIcon />}
            >
              Send
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;
